import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import { SortEvent } from '@shared/components/table/sort/model/sort.model';
import { ConsumptionRequestListFilter } from '@pages/my-consumption/consumption/ui/consumption-request-list/model/consumption-request-list.filter';
import { ConsumptionRequest } from '@core/domain/model/consumption/consumption-request.model';
import {
  AcsConsumption,
  AcsConsumptionGraphType,
  ClimateConsumption,
  ClimateConsumptionGraphType,
  ConsumptionInvoicesFilter,
  ConsumptionInvoicesTabCode,
  HousingModel,
  RoomModel,
  ReportModel,
} from '@core/domain/model/consumption-invoices/consumption-invoices.model';

export interface ConsumptionInvoicesState {
  tabs: Array<ConsumptionInvoicesTabCode>;
  currentTab: ConsumptionInvoicesTabCode;
  requestList: {
    data: ConsumptionRequest[];
    filter: ConsumptionRequestListFilter;
    page: PaginatorInput;
    sort: SortEvent;
    error: string | null;
  };
  informesUser: {
    data: ReportModel[];
    error: string | null;
  };
  graphs: {
    climate: {
      filter: ConsumptionInvoicesFilter | null;
      graphType: ClimateConsumptionGraphType;
      previousData: ClimateConsumption[] | null;
      currentData: ClimateConsumption[] | null;
      error: boolean | null;
    };
    acs: {
      filter: ConsumptionInvoicesFilter | null;
      graphType: AcsConsumptionGraphType;
      previousData: AcsConsumption[] | null;
      currentData: AcsConsumption[] | null;
      error: boolean | null;
    };
  };
  housingClimate: HousingModel[] | null;
  roomsClimate: RoomModel[] | null;
  housingAcs: HousingModel[] | null;
  roomsAcs: RoomModel[] | null;
}

export const consumptionInvoicesInitialState: ConsumptionInvoicesState = {
  tabs: ['climate', 'acs'],
  currentTab: 'climate',
  requestList: {
    data: [],
    filter: {},
    page: {
      pageIndex: 1,
      pageSize: 5,
    },
    sort: {
      sortName: 'requestDate',
      sortDir: 'desc',
    },
    error: null,
  },
  informesUser: {
    data: [],
    error: null,
  },
  graphs: {
    climate: {
      filter: null,
      graphType: 'line',
      previousData: null,
      currentData: null,
      error: null,
    },
    acs: {
      filter: null,
      graphType: 'line',
      previousData: null,
      currentData: null,
      error: null,
    },
  },
  housingClimate: null,
  roomsClimate: null,
  housingAcs: null,
  roomsAcs: null,
};
